import styled from 'styled-components';

export const TicketWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #78909c;
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 22px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
